<div class="container mt-4">
<div class="py-2"></div>
  <!-- Card Form -->
  <div class="card shadow-lg p-3 mb-4">
    <div class="card-header bg-primary text-white">
      <h5 class="mb-0">{{ editingId ? 'Update Shipping Partner' : 'Add New Shipping Partner' }}</h5>
    </div>
    <div class="card-body">
      <form [formGroup]="shippingForm" (ngSubmit)="save()" novalidate>
        <div class="row g-3">

          <div class="col-md-5">
            <label class="form-label">Shipping Partner Name <span class="text-danger">*</span></label>
            <input type="text" class="form-control" formControlName="shippingPartner" />
            <div class="text-danger mt-1" *ngIf="isInvalid('shippingPartner')">
             Shipping partner name is required
            </div>
          </div>

          <div class="col-md-2">
            <label class="form-label">State</label>
            <select class="form-select" formControlName="state">
              <option value="">Select State</option>
              <option *ngFor="let s of states" [value]="s">{{ s }}</option>
            </select>
            <div class="text-danger mt-1" *ngIf="isInvalid('state')">
              State is required.
            </div>
          </div>

          <div class="col-md-2">
            <label class="form-label">Amount</label>
            <input type="number" class="form-control" formControlName="amount" min="0"  (keypress)="allowOnlyNumbers($event)"/>
            <div class="text-danger mt-1" *ngIf="isInvalid('amount')">
              Amount must be a number.
            </div>
          </div>

          <div class="col-md-2">
            <label class="form-label">Status</label>
            <select class="form-select" formControlName="isActive">
              <option value="" selected>Select a status</option>
              <option value="true">Yes</option>
              <option value="false">No</option>
            </select>
            <div class="text-danger mt-1" *ngIf="isInvalid('isActive')">
              Status is required.
            </div>
          </div>

        </div>

        <div class="mt-3">
          <button type="submit" class="btn btn-success">{{ editId ? 'Update' : 'Save' }}</button>
          <button type="button" class="btn btn-secondary ms-2" (click)="resetForm()">Reset</button>
        </div>
      </form>
    </div>
  </div>

  <!-- Table Card -->
  <div class="card shadow-lg rounded-4">

  <!-- Card Header with Search -->
  <div class="card-header bg-dark text-white d-flex justify-content-between align-items-center">
    <h5 class="mb-0">Shipping Partner List</h5>

    <input
      type="text"
      class="form-control form-control-sm w-25"
      placeholder="🔍 Search district..."
      [(ngModel)]="searchText"
    />
  </div>
    <div class="card-body p-0">
      <div class="table-responsive" style="max-height: 300px; overflow-y: auto;">
        <table class="table table-striped table-hover mb-0 text-center">
          <thead class="table-light sticky-top">
            <tr>
              <th>S.No</th>
              <th>Shipping Partner Name</th>
              <th>State Name</th>
              <th>Amount</th>
              <th>Status</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let s of shippingList | filter: searchText; let i = index">
                <td>{{ i+1}}</td>
              <td>{{ s.shippingPartner }}</td>
              <td>{{ s.state }}</td>
              <td>{{ s.amount }}</td>
              <td>{{ s.isActive == true ? 'Yes' : 'No' }}</td>
              <td>
                <button class="btn btn-sm btn-warning" (click)="edit(s)">Edit</button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>

</div>
